/** These are general use utilities that are to be used in more than one place, but that don't require the use of mixins. */

// eslint-disable-next-line
export function getCollateralImageURL({ file_content_type, image }) {
  /**
   * This function checks if a given collateral is a video, in which case it adds a play button on top of the preview
   * image, and then returns the preview image URL. If not a video, it simply returns the image URL.
   *
   * INPUT: collateral, e.g. an element of the images prop in /src/components/CollateralSelector.vue
   * OUTPUT: image URL
   * */
  // eslint-disable-next-line
  if (file_content_type && file_content_type === 'video/mp4' && image) {
    const urlObj = new URL(image);
    const playButton = 'https://seer.imgix.net/media/public/play-button.png';
    urlObj.searchParams.set('mark-align', 'center,middle');
    urlObj.searchParams.set('mark-scale', '15');
    urlObj.searchParams.set('mark', playButton);
    return urlObj.href;
  } else {
    return image;
  }
}

/** Converts object to csv string */
export function objectToCsv(object) {
  const keys = Object.keys(object[0]);
  let csv = `${keys.join(',')}\n`;
  object.forEach((item) => {
    csv += `${keys.map((k) => item[k]).join(',')}\n`;
  });
  return csv;
}

/** Triggers the browser to generate a file download with the content of the string passed. */
// TODO: Verify that not using $nextTick is not an issue here.
export function downloadStringAsFile(stringData, filename, mimetype = 'text/plain') {
  const blob = new Blob([stringData]);
  return new Promise((resolve, reject) => {
    try {
      console.log({ filename, stringData, mimetype });
      if (window.navigator.msSaveOrOpenBlob) window.navigator.msSaveBlob(blob, filename);
      else {
        const link = document.createElement('a');
        link.download = filename;
        link.href = window.URL.createObjectURL(blob, {
          type: mimetype,
        });
        link.click();
        link.remove();
        resolve();
      }
    } catch {
      reject();
    }
  });
}

export default {
  getCollateralImageURL,
  objectToCsv,
  downloadStringAsFile,
};
